(function () {
  'use strict';

  var TAX_RATE = 1.19;

  var MONEY_FORMAT = window.MONEY_FORMAT || '';

  function formatMoney(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function bind(el) {
    if (el.__nettoBound) return;
    el.__nettoBound = true;

    var details = el.closest('[data-product-details]');
    if (!details) return;
    var netSpan = details.querySelector('.product__net-price span');
    if (!netSpan) return;
    var moneyFormat = MONEY_FORMAT;

    function update(variant) {
      if (!variant) return;
      var netCents = Math.round(variant.price / TAX_RATE);
      netSpan.innerHTML = formatMoney(netCents, moneyFormat);
    }

    el.addEventListener('variant-change', function (e) {
      update(e && e.detail ? e.detail.variant : null);
    });

    if (typeof el.getVariant === 'function') {
      el.getVariant().then(update);
    }
  }

  document.querySelectorAll('[data-variant-selection]').forEach(bind);
})();
